<script setup lang="ts">
import { mergeProps } from 'vue'
import { storeToRefs } from 'pinia'
import { useNotatStore } from '@/modules/notater/store'

const { notaterMedUlesteMeldinger } = storeToRefs(useNotatStore())

defineProps(['menu'])
</script>

<template>
  <v-menu>
    <template #activator="{ props: menuProps }">
      <v-tooltip :disabled="$vuetify.display.lgAndUp" :text="menu.text" location="bottom">
        <template #activator="{ props: tooltipProps }">
          <v-btn
            block
            :disabled="menu.disabled"
            v-bind="mergeProps(menuProps, tooltipProps)"
            :to="menu.route"
            :size="$vuetify.display.lgAndUp ? 'default' : 'small'"
            :aria-label="menu.text"
          >
            {{ $vuetify.display.lgAndUp ? menu.text : '' }}
            <template v-if="$vuetify.display.lgAndUp" #append>
              <v-badge
                v-if="menu.icon === 'mdi-note' && notaterMedUlesteMeldinger.length > 0"
                color="warning"
                :content="notaterMedUlesteMeldinger.length"
              >
                <v-icon>{{ menu.icon }}</v-icon>
              </v-badge>
              <v-icon v-else>
                {{ menu.icon }}
              </v-icon>
            </template>
            <template v-if="!$vuetify.display.lgAndUp">
              <v-badge
                v-if="menu.icon === 'mdi-note' && notaterMedUlesteMeldinger.length > 0"
                color="warning"
                :content="notaterMedUlesteMeldinger.length"
              >
                <v-icon>{{ menu.icon }}</v-icon>
              </v-badge>
              <v-icon v-else>
                {{ menu.icon }}
              </v-icon>
            </template>
          </v-btn>
        </template>
      </v-tooltip>
    </template>
  </v-menu>
</template>
